var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"progress",staticClass:"progress",class:{'is-dark': _vm.dark}},[_c('div',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm._f("round")(_vm.percent)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }